// extracted by mini-css-extract-plugin
export default {"warningsPage":"WarningsComponent_warningsPage__Pn1P9"};